import { createRoute } from '@signal/router'

export const NOT_FOUND = createRoute('not-found')

export const LOGIN = createRoute('login')
export const LOGOUT = createRoute('logout')
export const UNAUTHORIZED = createRoute('unauthorized')
export const PROFILE = createRoute('profile')
export const ACCOUNTS = createRoute(PROFILE, 'accounts')

export const ACCOUNT = createRoute('account/:accountId')
